import { render, staticRenderFns } from "./ServiceTabList.vue?vue&type=template&id=66996f62&scoped=true&"
import script from "./ServiceTabList.vue?vue&type=script&lang=js&"
export * from "./ServiceTabList.vue?vue&type=script&lang=js&"
import style0 from "./ServiceTabList.vue?vue&type=style&index=0&id=66996f62&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66996f62",
  null
  
)

export default component.exports